module.exports = __webpack_public_path__ + "img/Frame.b2045826.svg";